import 'config/globals';
import React from 'react';
import ReactDOM from 'react-dom';
import './config/ReactotronConfig';
import { Router, HashRouter } from 'react-router-dom';

import history from 'services/history';
import App from './App';

const startApp = () => {
  ReactDOM.render(
    <Router history={history}>
      <App />
    </Router>,
    document.getElementById('root'),
  );
};

const startAppCordova = () => {
  window.open = window.cordova.InAppBrowser.open;
  ReactDOM.render(
    <HashRouter>
      <App />
    </HashRouter>,
    document.getElementById('root'),
  );
};

if (!window.cordova) {
  startApp();
} else {
  document.addEventListener('deviceready', startAppCordova, false);
}
